export const apiEventserviceEndpoint = process.env.VUE_APP_API_EVENTSERVICE_ENDPOINT
export const apiMemberserviceEndpoint = process.env.VUE_APP_API_MEMBERSERVICE_ENDPOINT
export const vueAppTitle = process.env.VUE_APP_TITLE
export const redirectUrl =
  process.env.VUE_APP_REDIRECT_URL ||
  (typeof window !== 'undefined' ? window.location.origin : undefined)


export default {
  apiEventserviceEndpoint,
  apiMemberserviceEndpoint,
  vueAppTitle,
  redirectUrl
}
